export enum FiLocalSearchPropertyType {
    Names,
    Creators,
    Tags,
    BusinessAreas,
    Roles,
    BusinessUnits,
    Areas,
    Clusters,
    EmailAddressContacts,
    PhoneNumberContacts,
    Addresses,
    DataFieldValues,
    ObjectIds,
    ObjectTypeNames,
    Checklists,
    MediaBankFileExtensions,
    Checkpoints,
    Content = -1,
}
